import { Component } from '@angular/core';
import { SideMenuComponent } from '../side-menu/side-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-shareholder',
  standalone: true,
  imports: [SideMenuComponent, TranslateModule],
  templateUrl: './shareholder.component.html',
  styleUrl: './shareholder.component.css'
})
export class ShareholderComponent {

  baseApiUrl = environment.baseApiUrl;

}
